"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = SelectField;

var _react = _interopRequireWildcard(require("react"));

var _TextField = _interopRequireDefault(require("@material-ui/core/TextField"));

var _MenuItem = _interopRequireDefault(require("@material-ui/core/MenuItem"));

var _FormControl = _interopRequireDefault(require("@material-ui/core/FormControl"));

var _FormLabel = _interopRequireDefault(require("@material-ui/core/FormLabel"));

var _Autocomplete = _interopRequireDefault(require("@material-ui/lab/Autocomplete"));

var _Dialog = _interopRequireDefault(require("@material-ui/core/Dialog"));

var _DialogActions = _interopRequireDefault(require("@material-ui/core/DialogActions"));

var _DialogContent = _interopRequireDefault(require("@material-ui/core/DialogContent"));

var _DialogContentText = _interopRequireDefault(require("@material-ui/core/DialogContentText"));

var _DialogTitle = _interopRequireDefault(require("@material-ui/core/DialogTitle"));

var _Button = _interopRequireDefault(require("@material-ui/core/Button"));

var _lodash = require("lodash");

var _Tooltip = _interopRequireDefault(require("../Tooltip"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function SelectField(props) {
  var options = props.options;
  var autocomplete = props.autocomplete;
  if (!options) return null;

  if (props.hasPlaceholder && !autocomplete) {
    var defaultOption = {
      value: props.hasPlaceholder,
      label: props.hasPlaceholder
    };
    options.unshift(defaultOption);
  }

  var filteredOptions = (0, _lodash.uniqBy)(options, 'value');

  var _useState = (0, _react.useState)(filteredOptions[0].value),
      _useState2 = _slicedToArray(_useState, 2),
      selectedOption = _useState2[0],
      setSelectedOption = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = _slicedToArray(_useState3, 2),
      autocompleteSelection = _useState4[0],
      setAutocompleteSelection = _useState4[1];

  var _useState5 = (0, _react.useState)(false),
      _useState6 = _slicedToArray(_useState5, 2),
      dialogOpen = _useState6[0],
      setDialogOpen = _useState6[1];

  var _useState7 = (0, _react.useState)(0),
      _useState8 = _slicedToArray(_useState7, 2),
      key = _useState8[0],
      setKey = _useState8[1];

  var handleInputSubmit = props.handleInputSubmit;

  var handleChange = function handleChange(val, autocomplete) {
    setSelectedOption(autocomplete ? val.value : val);
    handleInputSubmit && handleInputSubmit(props.name.replace(' ', ''), autocomplete ? val.value : val);
  };

  var onSelectUpdate = function onSelectUpdate(val) {
    handleChange(val);
  };

  var onDialogClose = function onDialogClose(selection) {
    if (selection) {
      handleChange(autocompleteSelection, true);
      setDialogOpen(false);
    } else {
      setKey(key + 1);
      handleChange('', false);
      setDialogOpen(false);
    }
  };

  if (autocomplete) {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_Dialog.default, {
      open: dialogOpen,
      onClose: function onClose() {
        return onDialogClose(false);
      },
      "aria-labelledby": "alert-dialog-title",
      "aria-describedby": "alert-dialog-description"
    }, /*#__PURE__*/_react.default.createElement(_DialogTitle.default, {
      style: {
        marginBottom: 0,
        marginTop: 12,
        fontSize: 28
      },
      component: "h2",
      color: "secondary",
      id: "alert-dialog-title"
    }, "Confirm Dispensary"), /*#__PURE__*/_react.default.createElement(_DialogContent.default, null, /*#__PURE__*/_react.default.createElement(_DialogContentText.default, {
      component: "p",
      color: "secondary",
      id: "alert-dialog-description"
    }, autocompleteSelection && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, autocompleteSelection.label, /*#__PURE__*/_react.default.createElement("br", null), autocompleteSelection.address))), /*#__PURE__*/_react.default.createElement(_DialogActions.default, null, /*#__PURE__*/_react.default.createElement(_Button.default, {
      color: "secondary",
      variant: "contained",
      onClick: function onClick() {
        return onDialogClose(true);
      },
      disableElevation: true
    }, "Yes"), /*#__PURE__*/_react.default.createElement(_Button.default, {
      color: "secondary",
      variant: "contained",
      style: {
        opacity: 0.7
      },
      onClick: function onClick() {
        return onDialogClose(false);
      },
      disableElevation: true
    }, "No"))), /*#__PURE__*/_react.default.createElement(_FormControl.default, {
      component: "fieldset",
      fullWidth: true
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "flex"
    }, /*#__PURE__*/_react.default.createElement(_FormLabel.default, {
      component: "legend",
      style: props.error ? {
        color: '#AD0000'
      } : {},
      className: "mr-5"
    }, props.label, props.required && '*', props.error && /*#__PURE__*/_react.default.createElement("span", {
      style: {
        marginLeft: '10px'
      }
    }, props.error)), props.tooltip && /*#__PURE__*/_react.default.createElement(_Tooltip.default, {
      title: props.tooltip
    })), /*#__PURE__*/_react.default.createElement(_Autocomplete.default, {
      options: filteredOptions,
      fullWidth: true,
      id: "select-something",
      name: props.name,
      key: key,
      onChange: function onChange(event, val) {
        if (val) {
          setAutocompleteSelection(val);
          setDialogOpen(true);
        } else {
          handleChange('', false);
        }
      },
      variant: "outlined",
      required: props.required,
      error: props.error,
      renderInput: function renderInput(params) {
        return /*#__PURE__*/_react.default.createElement(_TextField.default, _extends({
          placeholder: props.hasPlaceholder,
          error: props.error
        }, params, {
          variant: "outlined"
        }));
      },
      getOptionLabel: function getOptionLabel(option) {
        return option.value;
      },
      getOptionSelected: function getOptionSelected(option, value) {
        return option.value === value.value;
      }
    })));
  }

  return /*#__PURE__*/_react.default.createElement(_FormControl.default, {
    component: "fieldset",
    fullWidth: true
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "flex"
  }, /*#__PURE__*/_react.default.createElement(_FormLabel.default, {
    component: "legend",
    style: props.error ? {
      color: '#AD0000'
    } : {},
    className: "mr-5"
  }, props.label, props.required && '*', props.error && /*#__PURE__*/_react.default.createElement("span", {
    style: {
      marginLeft: '10px'
    }
  }, props.error)), props.tooltip && /*#__PURE__*/_react.default.createElement(_Tooltip.default, {
    title: props.tooltip
  })), /*#__PURE__*/_react.default.createElement(_TextField.default, {
    fullWidth: true,
    id: "select-something",
    select: true,
    name: props.name,
    value: selectedOption,
    onChange: function onChange(e) {
      return onSelectUpdate(e.target.value);
    },
    variant: "outlined",
    required: props.required,
    error: props.error
  }, filteredOptions.map(function (option, i) {
    return /*#__PURE__*/_react.default.createElement(_MenuItem.default, {
      key: option.value,
      value: option.value,
      disabled: i === 0 && props.hasPlaceholder && true
    }, option.label);
  })));
}